function generateId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

const tabId = generateId();

let currentFlowId: string | null = null;

export function getTabId(): string {
  return tabId;
}

export function startFlow(flowId?: string): string {
  currentFlowId = flowId ?? generateId();
  return currentFlowId;
}

export function getFlowId(): string | null {
  return currentFlowId;
}

export function clearFlowId(): void {
  currentFlowId = null;
}

export { generateId };
